<template>
  <div class="padding">
    <div v-if="!prevOrders.length">
      The customer has no previous orders

      <button @click="closeWindow">
        Close window
      </button>
    </div>

    <div v-if="customer">
      <h2 class="text-center no-margin-top capitalize">
        {{ customer.first_name }} {{ customer.last_name }}
      </h2>
    </div>
    <div class="border small-margin-bottom small-padding" v-for="(prevOrder, index) in prevOrdersComputed" :key="prevOrder.id">
      <div class="prevorder-title text-center">
        <h2 class="no-margin">Box {{ prevOrders.length - index }}</h2>
      </div>

      <div class="flex small-margin-bottom">
        <div class="column-details flex flex-column justify-content-between">
          <div class="feedback-item">
            <h5 class="no-margin">Box Rating</h5>
            <div v-if="prevOrder.feedback.rating">
              <span
                :key="n.id"
                v-for="n in parseInt(prevOrder.feedback.rating)"
                class="feedback-answser"
              >
                &#9733;
              </span>
            </div>
          </div>
          <div class="feedback-item">
            <h5 class="no-margin">Style</h5>
            <span class="feedback-answer">{{ feedbackStyle(prevOrder.feedback) }}</span>
          </div>
          <div class="feedback-item">
            <h5 class="no-margin">Colors</h5>
            <span class="feedback-answer">{{ feedbackColor(prevOrder.feedback) }}</span>
          </div>
          <div class="feedback-item">
            <h5 class="no-margin">Price Level</h5>
            <span class="feedback-answer">{{ feedbackPrice(prevOrder.feedback) }}</span>
          </div>
        </div>

        <div class="column-feedback">
          <strong>Order feedback</strong>
          <p class="feedback-text">
            {{ prevOrder.feedback.feedback }}
          </p>
        </div>

        <div class="column-products flex flex-wrap relative">
          <div class="pickup-badge" v-if="prevOrder.returned_to_sender">
            <div class="badge-view">Not Picked up</div>
          </div>
          <div
            class="product clickable"
            v-for="product in prevOrder.products"
            :key="product.id"
            :class="{ 'has-feedback': product.feedback }"
            @click="showProductModal(product)"
          >
          <div class="product-image" v-lazy-container="{ selector: 'img' }">
            <img :data-src="product.image" alt="order image">
          </div>
            <div class="return-reason very-small-margin-left very-small-margin-right" v-if="product.return_reasons.length">
              <p
                class="very-small-margin-top very-small-margin-bottom text-center"
                style="font-size: 12px; color: #f00;"
                v-for="reason in product.return_reasons"
                :key="reason.id"
              >
                {{ reason.reason ? reason.reason.name : '' }}
              </p>
            </div>
            <span v-if="product.feedback" class="feedback-indicator"></span>
            <p class="feedback-container">{{ product.feedback }}</p>
            <span class="product-marker" :class="{ 'dislike': product.return_reasons.length || product.return_reason }">
              {{ product.return_reasons.length || product.return_reason ? '&#10005;' : '&#10003;' }}
            </span>
          </div>
        </div>
      </div>

      <span>
        Order #{{ prevOrder.order_id }} - {{ prevOrder.status }} - {{ prevOrder.date }}
      </span>
    </div>

    <modal name="ProductModal" v-if="productModalShow" @close="productModalShow = false">
      <div v-click-outside="() => { productModalShow = false }">
        <div class="flex very-small-padding">
          <product-gallery :images="selectedProduct.imagesList" />
          <div class="product-info-wrapper flex flex-column border full-width small-margin-left">
            <div class="border-top border-bottom flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <strong>Title</strong>
              <strong>{{ selectedProduct.post_title }}</strong>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Style</span>
              <span>{{ selectedProduct.style }}</span>
            </div>
            <div class="border-top border-bottom flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Description &nbsp; &nbsp;</span>
              <span style="text-align: right;">{{ selectedProduct.description }}</span>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Brand</span>
              <span>{{ selectedProduct.brand }}</span>
            </div>
            <div class="border-top border-bottom flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Price</span>
              <span>{{ selectedProduct.price }} {{ selectedProduct.price.currency }}</span>
            </div>
            <div class="flex justify-content-between bg-light-grey small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Fit</span>
              <span></span>
            </div>
            <div class="border-top border-bottom flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Color</span>
              <span>{{ selectedProduct.colorText }}</span>
            </div>
            <div class="flex justify-content-between bg-light-grey small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Material</span>
              <span>{{ selectedProduct.materialText }}</span>
            </div>
            <div class="border-top border-bottom flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Product ID</span>
              <span>
                <router-link :to="{ path: `/product/${selectedProduct.id}` }" target="_blank">
                  {{ selectedProduct.id }}
                </router-link>
              </span>
            </div>
            <div class="flex justify-content-between bg-light-grey small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>SKU ID</span>
              <span>{{ selectedProduct.sku }}</span>
            </div>
            <div class="border-top  flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Size</span>
              <span>
                {{ selectedProduct.size }}
              </span>
            </div>
          </div>
        </div>

        <div class="flex flex-column small-padding">
          <h5 class="very-small-margin-bottom no-margin-top">Feedback:</h5>
          <textarea name="feedback" id="" rows="5" readonly v-model="selectedProduct.feedback" style="font-size: 16px;"></textarea>
        </div>

        <div class="flex justify-content-between small-padding-right small-padding-left">
          <button class="bg-red" style="margin-left: auto;" @click="productModalShow = false">Close</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import ProductGallery from '../ProductGallery.vue'

let loader

export default {
  name: 'PreviousOrders',

  components: {
    ProductGallery
  },

  data () {
    return {
      prevOrders: [],
      selectedProduct: null,
      productModalShow: false
    }
  },

  computed: {
    prevOrdersComputed () {
      return this.prevOrders.map(prevOrder => {
        return {
          ...prevOrder,
          products: prevOrder.products.sort((a, b) =>
            (a.return_reasons.length - b.return_reasons.length)
          ).sort((a, b) => Number(a.return_reason) - Number(b.return_reason))
        }
      }).sort((a, b) => {
        return new Date(a.date) > new Date(b.date) ? -1 : 1
      })
    },
    customer () {
      return this.prevOrders.length > 0 && this.prevOrders[0].customer
    }
  },

  methods: {
    feedbackColor (feedback) {
      switch (feedback.color_combination) {
        case 1:
          return 'Too Colorful'
        case 2:
          return 'Appropriate'
        case 3:
          return 'Too boring'
        default:
          return 'N/A'
      }
    },
    feedbackStyle (feedback) {
      switch (feedback.how_was_the_style) {
        case 1:
          return 'Too challenging'
        case 2:
          return 'Appropriate'
        case 3:
          return 'Too auntie'
        default:
          return 'N/A'
      }
    },
    feedbackPrice (feedback) {
      switch (feedback.how_was_the_price) {
        case 1:
          return 'Too cheap'
        case 2:
          return 'Appropriate'
        case 3:
          return 'Too expensive'
        default:
          return 'N/A'
      }
    },

    closeWindow () {
      window.close()
    },

    showProductModal (product) {
      this.selectedProduct = {
        ...product,
        imagesList: [{
          urls: {
            original: product.image
          }
        }]
      }

      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.productModalShow = true
      }, 100)
    }
  },

  mounted () {
    Vue.api.get(`/order/${this.$route.query.order_id}/previous-styling-orders`, {}, {
      before: () => loader = this.$loading.show(),
      always: () => loader.hide(),
      callback: res => {
        this.prevOrders = res
      }
    })
  }
}
</script>

<style lang="less" scoped>
.pickup-badge {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .badge-view {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 418px;
    height: 150px;
    background: rgba(240, 148, 145, 0.9);
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 49px;
    color: white;
    text-align: center;
  }
}
.prevorder-title {
  margin: -15px -15px 10px;
  padding: 5px 10px;
  background: #001720;
  color: #fff;
  font-size: 20px;
}
.column-details {

  .feedback-item {
    background: #e8887b;
    padding: 10px 20px;
    border-radius: 5px;
    height: 50px;
    width: 140px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 18px;

    &:not(:last-of-type) {
      margin-bottom: 5px;
    }
  }
}

.column-feedback {
  // width: 400px;
  background: #eee;
  border: 2px solid #aaa;
  border-radius: 5px;
  margin: 0 30px;
  padding: 10px;

  .feedback-text {
    width: 540px;
  }
}

.column-products {
  max-width: 960px;
  margin: auto;
}

.product {
  width: 160px;
  position: relative;

  .product-marker {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 160, 0, .5);
    border: 2px solid #008700;
    font-size: 24px;
    font-weight: 700;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.dislike {
      background: rgba(160, 0, 0, .5);
      border: 2px solid #a0000080;
    }
  }
}
.product-image {
  margin: 5px 8px;
  height: 180px;

  img {
    height: 100%;
    max-width: 100%;
  }
}

/deep/.product-gallery-image {
  border: none;
}

.feedback-indicator {
  width: 20px;
  height: 20px;
  background: red;
  display: block;
  border-radius: 50%;
  position: absolute;
  top: 0;
}

.feedback-container {
  display: none;
  position: absolute;
  top: 10px;
  padding: 10px;
  background: #eee;
  z-index: 102;
}

.has-feedback:hover > .feedback-container {
  display: block;
}
</style>
